export default "__VITE_ASSET__BFAzcsve__"